var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ds-radio",on:{"click":_vm.handleClick}},[_c('input',{ref:"element",staticClass:"ds-radio__input",attrs:{"id":_vm.id,"name":_vm.name,"type":"radio"},domProps:{"checked":_vm.radioChecked}}),_c('div',{staticClass:"ds-radio__icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }